import React from 'react';
import { useTranslation } from 'react-i18next';
import { Cell } from '../../grid/Cell';
import { Grid } from '../../grid/Grid';
import { Icon } from '../../icons/Icon';
import { UploadMethodsProps } from '../CreateUploadMethod';
import styles from './UploadMethodsButtons.module.scss';

export const UploadMethodsButtons = ({ methods, openSource }: Props) => {

    const { t } = useTranslation();

    return (
        <Grid gap='xs' align='center' justify='center' wrap>
            {methods.ExternalUpload && (
                <Cell className={styles.cell}>
                    <div onClick={() => openSource('ExternalUpload')}
                        className={styles.source}>

                        <Icon type='general-ui-devices'
                            size='large'
                            strokeWidth={1.25}
                            className={styles.icon} />

                        {t('upload_methods.other_sources.device')}
                    </div>
                </Cell>
            )}
        </Grid>
    );
};

type Props = {
    methods: UploadMethodsProps;
    openSource: (key: keyof UploadMethodsProps) => void;
};